import { useBunja } from 'bunja/react';

import { FormattedMessage } from '@flipster/i18n';
import { Button } from '@flipster/react/design-system/button';
import { css } from '@flipster/styled-system/css';
import StarFilledIcon from '@flipster/ui/assets/svgs/unfilled/star-filled.svg';

import { marketPageBunja } from '../../../state';

export const NoFavoriteData = () => {
  const { tab: marketTab } = useBunja(marketPageBunja);
  return (
    <section
      className={css({
        minHeight: '70vh',
        margin: '68px 0',
        textAlign: 'center',
      })}
    >
      <StarFilledIcon className={css({ width: 56, height: 56, mb: 24 })} />
      <p
        className={css({
          textStyle: 'Title/S',
          mb: 8,
          color: 'inverse.white',
        })}
      >
        <FormattedMessage id='Market.r250923.No_favorites_yet' />
      </p>
      <p
        className={css({
          textStyle: 'Text/L/Regular',
          color: 'content.default.level-5',
          mb: 24,
          tabletDown: { whiteSpace: 'break-spaces' },
        })}
      >
        <FormattedMessage id='Market.r250923.Favorites_can_added' />
      </p>
      <Button
        as='a'
        hierarchy='primary'
        color='neutral'
        size='large'
        href={marketTab === 'spot' ? '/trade/spot' : '/trade/perpetual'}
        label={<FormattedMessage id='Market.r250923.Added_to_favorites' />}
      />
    </section>
  );
};
